import { Http } from "api/Http";

const Api = new Http("patients/1/patient");

class BalanceAPI {
  constructor(api) {
    this.api = api;
  }

  getBalance = async patientId => {
    let res = await this.api.get("/", patientId + "/balance");
    return res.data || {};
  };
}

const newApi = new BalanceAPI(Api);
export default newApi;
